// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"c2045671","373":"749352b8","453":"1f5ce2e0"}[chunkId] + ".chunk.js";
};